import './../node_modules/izitoast/dist/css/iziToast.min.css';


// Dynamic detection of base link according to environment.
let base;
let devHost = ['rklinic.com',];
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development' || devHost.includes(window.location.hostname) ) {
    base = "https://rklinic-admin.com/api/";
} else {
   base = "https://admin-seena.com/api/";
}


export const baseLink = base;

export const baseBlogImageUrl = "https://rkanjel.com/seena-blog/wp-content/uploads/";
export const getDoctorsLink = baseLink + "site/doctors/list";
export const getFollowedDoctorsURL = baseLink + "/doctors/my-list";
export const getAuthUserFollowedDoctors = baseLink + "site/my-doctors/list";
export const getSpecialtiesLink = baseLink + "specialities/list";
export const sendSubscribeEmail = baseLink + "system/subscription";
export const getSpecialtyDetailsLink = baseLink + "speciality/doctors";
export const getDoctorDetailsLink = baseLink + "doctor/profile";
export const getOffersLink = baseLink + "offers/all";
export const getOfferCategories = baseLink + "offer/categories";
export const getOfferDetailsURL = baseLink + "offers/details";
export const getDoctorBranchesLink = baseLink + "doctor/clinics";
export const getClinicDaysLink = baseLink + "clinic/days";
export const getClinicDayTimesLink = baseLink + "day/times";
export const getCurrentBookingFeesLink = baseLink + "reservation/fees";
export const getAddReservationLink = baseLink + "reservation/add";
export const rescheduleReservationLink = baseLink + "reservation/reschedule";
export const getAllUpcomingReservations = baseLink + "reservation/upcoming";
export const getCurrentReservationDetails = baseLink + "reservation/upcoming/details";
export const cancelReservationLink = baseLink + "reservation/set-status";
export const loginUrl = baseLink + "user/login";
export const registerUrl = baseLink + "user/sign-up";
export const activeAccountUrl = baseLink + "user/activate-account";
export const verifyCodeUrl = baseLink + "user/pin/verify";
export const ResendCodeUrl = baseLink + "sms/resend";
export const forgetPasswordUrl = baseLink + "user/forgot-password";
export const resetPasswordUrl = baseLink + "user/reset-password";
export const userProfileUrl = baseLink + "profile";
export const editUserProfileUrl = baseLink + "profile/edit";
export const plansUrl = baseLink + "patient/plans";
export const requestPlanUrl = baseLink + "premium-request";
export const citiesUrl = baseLink +  "doctors/provinces";
export const cancelPlanUrl = requestPlanUrl + "/cancel";
export const addRemoveDoctorToList = baseLink + "doctor/add-remove-list";
export const blogUrl = "https://rkanjel.com/api-blog-seena/";
export const getSliderAds = baseLink + "slider/ads";
export const getDoctorReviews = baseLink + "doctor/reviews";
export const addReview = baseLink + "review/add";
export const getPatientHistory = baseLink + "reservation/past";
export  const getCashBackRequestURL = baseLink + "cashback/request";
export const getDoctorServices = baseLink + "doctor/services";
export const addReportUrl = baseLink + "report/add";
export const redeemPromoCodeForReservationUrl = baseLink + "reservation/promo-code/redeem";
export const requestRefundURL = baseLink + "refund/request";
export const getHospitalProfileURL = baseLink + "hospital/profile";
export const getHospitalDoctorsURL = baseLink + "hospital/doctors";

/************ Constants **************/
export const DEFAULT_LANG = "en";

export const getHeader = () => {
    const token = localStorage.getItem('access_token');
    const lang = window.localStorage.getItem('seenaLang') ? window.localStorage.getItem('seenaLang') : DEFAULT_LANG;
    const header = {
        lang: lang,
        "Authorization": `Bearer ${JSON.parse(token)}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };
    return header
};


export const clearAccessTokenAndRedirectToLogin = (error) => {
    if (error && error.response && error.response.status === 401) {
        localStorage.removeItem("access_token");
        window.location.href = "/login"
    }
};
